// Public Inertia sayfalarının çözümü (İSTEMCİ tarafı).
//
// Bileşen adı, app/frontend/public/pages altındaki dosya yoludur:
//   render inertia: "home/show"   → app/frontend/public/pages/home/show.tsx
//   render inertia: "blog/index"  → app/frontend/public/pages/blog/index.tsx
//
// Kule sayfaları "kule/..." adıyla ayrı bir bundle'dadır (app/frontend/pages), çakışma yoktur.
// SSR tarafındaki eşi app/frontend/ssr/ssr.tsx içindedir (orada glob `eager` olmak zorunda;
// aynı dosyada iki glob tutmak istemci bundle'ındaki kod bölmeyi bozardı).

import type { ResolvedComponent } from '@inertiajs/react'
import { pageNotFound } from './pageNames'

type PageModule = { default: ResolvedComponent }

const pages = import.meta.glob<PageModule>('../pages/**/*.tsx')

// Inertia'nın ComponentResolver tipi `Promise<{default}>` kabul etmiyor, `Promise<Component>`
// kabul ediyor; bu yüzden modül burada açılır. `Show.layout` bileşenin statik alanı olduğu için
// açıldıktan sonra da korunur.
export async function resolvePublicPage(name: string): Promise<ResolvedComponent> {
  const loader = pages[`../pages/${name}.tsx`]
  if (!loader) pageNotFound(name, Object.keys(pages))

  const module: PageModule = await loader()
  return module.default
}
